const describeAppFundaContactRequestNewCondition = (): string =>
  'een nieuw Funda contactverzoek is opgevraagd';

export default describeAppFundaContactRequestNewCondition;
